// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import {pulse,since} from './mechanismTiming';
import {BALL_RADIUS} from '@core/sim/constants';
export const KICKER_PRESENTATION={outSteps:18,backSteps:80,scoopThrow:.028,kickbackThrow:.0115} as const;
/** The caller supplies the existing authoritative BallEjected stamp, never frame time. */
export function kickerEjectStroke(step:number,ejectedAtStep:number,scoop:boolean):number{
 return pulse(since(step,ejectedAtStep),KICKER_PRESENTATION.outSteps,KICKER_PRESENTATION.backSteps)*(scoop?KICKER_PRESENTATION.scoopThrow:KICKER_PRESENTATION.kickbackThrow);
}
/** A held scoop ball is absent from physics. Active/ejected balls retain their canonical positions. */
export function heldScoopBallOffset(heldByScoop:boolean):number{return heldByScoop?-2*BALL_RADIUS:0}

import type {KickerDevice} from '@core/machine'
/** Stock kickback ID/coil carries explicit physical intent even with indefinite hold.
 * Other indefinite rule-controlled kickers retain scoop presentation; zero-hold defaults are lanes. */
export function isScoopKicker(d:Pick<KickerDevice,'kind'|'id'|'holdMs'|'coil'>):boolean {return d.kind==='kicker'&&d.id!=='kickback'&&d.coil!=='kickbackCoil'&&(d.holdMs??0)!==0}
